import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { NacidEventResponse, StudentEventRequest } from "../../models/dtos";

export const nacidEventsApi = createApi({
  reducerPath: "nacidEventsApi",
  baseQuery: baseAuthQuery("nacidEvent"),
  tagTypes: ["NacidEvent"],
  endpoints: (builder) => ({
    getActiveNacidEvents: builder.query<ApiResponse<NacidEventResponse[]>, void>({
      query: () => ({
        url: "getActiveNacidEvents",
        method: "GET",
      }),
      providesTags: ["NacidEvent"],
    }),
    insertStudentHistoryEventAndSendToNacid: builder.mutation<ApiResponse<boolean>, Partial<StudentEventRequest>>({
      query: (body) => ({
        url: "insertStudentHistoryEventAndSendToNacid",
        method: "POST",
        body,
      }),
      invalidatesTags: ["NacidEvent"],
    }),
  }),
});
